import React, { FC } from 'react';
import { css } from 'styled-components/macro';

const styles = {
    root: css`
        & > path {
            fill: ${({ theme }) => theme.colors.purple.light};
        }
        g {
            stroke: ${({ theme }) => theme.colors.purple.light};
            stroke-width: 3px;
            stroke-linecap: round;
            stroke-linejoin: round;
        }
    `,
};

const Female: FC = (props) => {
    return (
        <svg
            viewBox="0 0 54 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            css={styles.root}
            {...props}
        >
            <path d="M37.6303 34.9713C36.7347 34.9713 36.0087 34.2463 36.0087 33.352C36.0087 32.4577 36.7347 31.7327 37.6303 31.7327C38.5259 31.7327 39.252 32.4577 39.252 33.352C39.252 34.2463 38.5259 34.9713 37.6303 34.9713Z" />
            <g>
                <path d="M27.0001 2C20.3698 2 14.0109 4.63019 9.32256 9.31197C4.63418 13.9937 2.00027 20.3436 2.00027 26.9646V75.3645H27.0001V60.7456H41.8199L44.7478 46.1266H52V26.9646C52 20.3436 49.3661 13.9937 44.6777 9.31197C39.9893 4.63019 33.6305 2 27.0001 2V2Z" />
                <path d="M1.99929 39.1996C11.3402 39.1983 20.3398 35.6927 27.2144 29.3777C34.089 23.0626 38.3369 14.399 39.1162 5.10376" />
                <path d="M2.00093 29.8884C9.37673 29.8886 16.4531 26.975 21.6854 21.7838C26.9178 16.5926 29.8811 9.54517 29.9287 2.17993" />
                <path d="M2.81082 20.5774C7.46251 20.3687 11.8677 18.4298 15.1603 15.1419C18.4528 11.8539 20.3945 7.45494 20.6035 2.80981" />
                <path d="M9.74707 75.3644V39.1995" />
                <path d="M17.4951 75.3646V36.5007" />
            </g>
        </svg>
    );
};

export default Female;
